import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found-component',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  shortUrlList = ['company', '/pages/partners/view/'];

  constructor(private router: Router) {}

  ngOnInit() {
    const url = this.router.url;
    this.shortUrlList.some((f) => {
      if (url.indexOf(f)) {
        this.router.navigate(['/pages/partners/view/']);
      }
    });
  }
}
